import { apiService } from './apiService';
import { API_ENDPOINTS } from '../constants/apiConstants';

export const predictionService = {
  // Create a new prediction
  createPrediction: async (predictionData) => {
    try {
      const response = await apiService.post(API_ENDPOINTS.PREDICTION, {
        name: predictionData.name,
        type: predictionData.type,
        prompt: predictionData.prompt
      });

      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Prediction created successfully'
      };
    } catch (error) {
      console.error('Create prediction error:', error);
      
      let errorMessage = 'Failed to create prediction. Please try again.';
      
      if (error.response) {
        // Check for 'detail' field (FastAPI style) or 'message' field
        const apiError = error.response.data?.detail || error.response.data?.message;
        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  },

  // Get all predictions
  getPredictions: async () => {
    try {
      const response = await apiService.get(API_ENDPOINTS.PREDICTION);

      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Predictions fetched successfully'
      };
    } catch (error) {
      console.error('Get predictions error:', error);
      
      let errorMessage = 'Failed to fetch predictions. Please try again.';
      
      if (error.response) {
        // Check for 'detail' field (FastAPI style) or 'message' field
        const apiError = error.response.data?.detail || error.response.data?.message;
        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  }
  ,

  // Update a prediction
  updatePrediction: async (predictionId, predictionData) => {
    try {
      const response = await apiService.patch(`${API_ENDPOINTS.PREDICTION}${predictionId}`, {
        name: predictionData.name,
        type: predictionData.type,
        prompt: predictionData.prompt
      });

      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Prediction updated successfully'
      };
    } catch (error) {
      console.error('Update prediction error:', error);
      let errorMessage = 'Failed to update prediction. Please try again.';
      if (error.response) {
        const apiError = error.response.data?.detail || error.response.data?.message;
        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  },

  // Delete a prediction
  deletePrediction: async (predictionId) => {
    try {
      const response = await apiService.delete(`${API_ENDPOINTS.PREDICTION}${predictionId}`);
      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Prediction deleted successfully'
      };
    } catch (error) {
      console.error('Delete prediction error:', error);
      let errorMessage = 'Failed to delete prediction. Please try again.';
      if (error.response) {
        const apiError = error.response.data?.detail || error.response.data?.message;
        errorMessage = apiError || errorMessage;
      } else if (error.request) {
        errorMessage = 'Network error. Please check your internet connection.';
      }

      return {
        success: false,
        message: errorMessage,
        error: error.response?.data || error.message
      };
    }
  }
};